export default "__VITE_ASSET__Cl3YM_6A__"